import React from 'react';
import RebootNotification from './RebootNotification.js';
const RebootEPINotification = ({ boxDetails, obiReboot }) => {
  const isESeries = boxDetails?.serialNumber && boxDetails?.serialNumber?.startsWith('E-')
  return (
    <div className="reboot-notification-container" style={{ justifyContent: isESeries ? 'center' : null }}>
      {boxDetails?.Obis &&
        boxDetails.Obis.map(item => {
          return item.rebootRequired ? (
            <RebootNotification macAddress={item.macAddress} deviceId={item.deviceId} onReboot={obiReboot} />
          ) : null;
        })}
    </div>
  );
};

export default RebootEPINotification;
